//PrimeReact
import { Tooltip } from "primereact/tooltip"
import { InputNumber } from "primereact/inputnumber"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import { useState } from "react"
import FormulaBuilderDragIcon from "./FormulaBuilderDragIcon"
import formulaBuilderTypes from "./formulaBuilderTypes"
import FormulaBuilderGroupingPanel from "./FormulaBuilderGroupingPanel"

export default function FormulaBuilderNumbers() {
  const [numberValue, setNumberValue] = useState(1)

  return (
    <>
      <FormulaBuilderGroupingPanel title="Numbers">
        Type in a number, then drag it onto the form to add it to the formula.
      </FormulaBuilderGroupingPanel>
      <div className={`${myStyles.numberLayout} ${myStyles.operatorContainer}`}>
        <div className={myStyles.numberLayoutInput}>
          <InputNumber
            showButtons
            buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            maxFractionDigits={20}
            inputStyle={{ textAlign: "center" }}
            value={numberValue}
            onChange={(e) => {
              setNumberValue(e.value)
            }}
            style={{ width: "100%", minWidth: "50px" }}
          />
        </div>
        <div className={myStyles.numberLayoutIcon}>
          <FormulaBuilderDragIcon
            id={formulaBuilderTypes.formulaTypes.number}
            type={formulaBuilderTypes.formulaTypes.number}
            object={numberValue}
          />
        </div>
      </div>
    </>
  )
}
